import React, { useState } from 'react'
import cn from 'classnames'
import style from './Start.module.css'

export const Start = ({setEnemy}) => {

    const [isGameStarted, setIsGameStarted] = useState(false)

    const startGame = (enemy)=>{
        setIsGameStarted(true)
        setEnemy(enemy)
    }

  return (
    <div className={cn(style.startScreen,{
        [style.active]: !isGameStarted
    })}>
    <div>
    <h1 className={style.gameTitle}>Tic-tac-toe</h1>
    <span className={style.gameSelect}
        onClick = {()=>startGame('solo')}
    >solo</span>
    <span className={style.gameSelect}
        onClick = {()=>startGame('bot')}
    >with-bot</span>
    </div>

  </div>
  )
}
